import { ChangeEvent, ReactNode } from 'react';
import * as React from 'react';

import { CheckBoxLabel, CheckBoxWrapper, StyledCheckBox } from './style';

export type CheckBoxProps = {
  htmlFor: string;
  children?: ReactNode;
  value?: string | number;
  disabled?: boolean;
  checked?: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const CheckBox: React.FC<CheckBoxProps> = props => {
  const { htmlFor, children, value, disabled, checked, onChange } = props;

  return (
    <CheckBoxWrapper>
      <StyledCheckBox
        id={htmlFor}
        type="checkbox"
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={e => onChange(e)}
        data-testid={`${htmlFor}-checkbox`}
      />
      <CheckBoxLabel disabled={disabled} htmlFor={htmlFor}>
        {children}
      </CheckBoxLabel>
    </CheckBoxWrapper>
  );
};

export default CheckBox;
